














































import Vue from 'vue';
export default Vue.extend({
  name: 'SwitchWithHand',
  data() {
    return {
      handIsLeaving: false,
    };
  },
  methods: {
    handRemoved() {
      this.$emit('animation-finished');
    },
    handFinishedMoving() {
      this.handIsLeaving = true;
    },
  },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shortcutInstructions/subcomponents/SwitchWithHand.vue